import { render, staticRenderFns } from "./li.vue?vue&type=template&id=22d13e24&"
import script from "./li.vue?vue&type=script&lang=js&"
export * from "./li.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports